import { useMatch as useReactRouterMatch } from 'react-router-dom';

import { type Routes } from '../types';

// Generic over `Path`, not just typed `path: Routes`: a wide, non-generic
// parameter forces `Path` to be inferred as the WHOLE `Routes` union at every
// call site, so `useReactRouterMatch`'s `ParamParseKey<Path>` distributes
// over every route pattern in the app and TypeScript picks an unrelated
// pattern's params (e.g. `membershipId` for a call that actually matches
// `tags/:id`) — which one it picks shifts whenever the route tree changes
// shape elsewhere. Being generic lets a literal argument narrow `Path` (and
// therefore `.params`) to just what was actually passed.
export default function useMatch<Path extends Routes>(path: Path) {
  return useReactRouterMatch(path);
}
